import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class withScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

export default withRouter(withScrollToTop);



// WEBPACK FOOTER //
// ./src/hocs/with-scroll-to-top/index.js